import { render, staticRenderFns } from "./newleave.vue?vue&type=template&id=2d4b509b&scoped=true"
import script from "./newleave.vue?vue&type=script&lang=js"
export * from "./newleave.vue?vue&type=script&lang=js"
import style0 from "./newleave.vue?vue&type=style&index=0&id=2d4b509b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b509b",
  null
  
)

export default component.exports